import { get, post } from "@/api/implementation/app/index.js";

export const warehouseOrders = () => get("trigger/send-open-orders-to-warehouse");

export const confirmWarehouseOrders = (limit) => post("trigger/send-open-orders-to-warehouse", { isConfirmed: true, limit });
